import * as requests from '../api-request'

export const getVoices = async (data) => {
  const queryString = new URLSearchParams(data)
  return requests.toJSON('GET', `table_read/voices?${queryString}`)
}

export const getAudios = async (data) => {
  const queryString = new URLSearchParams(data)
  return requests.toJSON('GET', `table_read/audios?${queryString}`)
}

export const generateAudio = async (data) => {
  const response = await requests.toJSON('POST', 'table_read/generate', data)
  return response.audio
}
export const createJob = (data) => {
  return requests.toJSON('POST', 'table_read/submit_job', data)
}

export const getRunningJob = (data) => {
  const queryString = requests.createQueryString(data)
  return requests.toJSON('get', `table_read/running_job?${queryString}`, data)
}

export const getCompletedJob = (data) => {
  const queryString = requests.createQueryString(data)
  return requests.toJSON('get', `table_read/completed_job?${queryString}`, data)
}

export const getLatestJob = (data) => {
  const queryString = requests.createQueryString(data)
  return requests.toJSON('get', `table_read/latest_job?${queryString}`, data)
}

export const getLimitStatus = () => {
  return requests.toJSON('get', 'table_read/limit_status')
}

export const autoSelectVoices = (data) => {
  return requests.toJSON('POST', 'table_read/auto_selected_voices', data)
}

// Server home for Table Read voice casting, replacing the browser-local
// `nolan_table_read_settings` store. A user who has not cast this script yet
// gets 200 with empty settings, not an error.
export const getSettings = (data) => {
  const queryString = requests.createQueryString(data)
  return requests.toJSON('GET', `table_read/settings?${queryString}`)
}

export const saveSettings = (data) => {
  return requests.toJSON('POST', 'table_read/settings', data)
}
